import { capitalize } from "lodash";
import { cdnImg } from "../../../Utils/cdnImage";
import moment from "moment";
import React, { useState } from "react";
import { formatWithCommas } from "../../../Utils/Toast";
import { toFixedWithoutRounding } from "../../../Utils/constants";

const ProfitLoss = ({ data, betCheckObj, tab }) => {
  const [active, setActive] = useState([]);
  console.log(data,'data')
  return data?.length > 0 ? (
    <tbody id="Matched_Content">
      {data?.map((item, index) => {
        return (
          item?.bets_list?.length > 0 && (
            <>
              <tr
                id="summary0"
                style={{ display: "table-row" }}
                tab={index + 1}
              >
                <td style={{ textAlign: "left" }} className="text-start">
                  <span style={{ textTransform: "uppercase" }}>
                    {betCheckObj[Number(item?.eventType)]}
                  </span>
                  <img
                    class="fromto"
                    src={cdnImg("assets/images/transparent.gif")}
                  />
                  <strong>
                    {tab === "casino"
                      ? item?.casinoName
                      : item?.matchName
                      ? item?.matchName
                      : item?.eventName}
                  </strong>
                  <img
                    class="fromto"
                    src={cdnImg("assets/images/transparent.gif")}
                  />
                  {tab == "Exchange" && item?.market}
                  {tab === "Sportsbook" && "SportBook"}
                  {tab === "Fancy" && "Fancy"}{" "}
                  {tab === "Casino" && item?.casinoType}{" "}
                  {tab === "bookmaker" && "Bookmaker"}{" "}
                </td>
                <td id="startTime">
                  {" "}
                  {moment(item?.eventDateTime).format("YYYY-MM-DD hh:mm:ss")}
                </td>
                <td id="settledDate">
                  {" "}
                  .{moment(item?.updatedAt).format("YYYY-MM-DD hh:mm:ss")}
                </td>
                <td className="text-end">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <span
                      style={{
                        color: item?.netAmount > 0 ? "green" : "red",
                      }}
                    >
                      {item?.netAmount > 0
                        ? formatWithCommas(Math.abs(item?.netAmount))
                        : `(${formatWithCommas(Math.abs(item?.netAmount))})`}
                    </span>

                    <span
                      style={{
                        color: "#2789ce",
                        marginLeft: "5px",
                      }}
                    >
                      {active.includes(item?._id) ? (
                        <img
                          style={{
                            height: "15px",
                          }}
                          onClick={() =>
                            setActive((prev) => {
                              return prev?.filter((res) => {
                                return res !== item?._id;
                              });
                            })
                          }
                          src={cdnImg("assets/images/expand-open.png")}
                        />
                      ) : (
                        <img
                          style={{
                            height: "15px",
                          }}
                          onClick={() =>
                            setActive((prev) => {
                              return [...prev, item?._id];
                            })
                          }
                          src={cdnImg("assets/images/expand-close.png")}
                        />
                      )}{" "}
                      {item?.matchBetId || item?.sessionBetId}
                    </span>
                  </div>
                </td>
              </tr>
              {item?.bets_list?.length > 0 && active?.includes(item?._id) && (
                <tr className="expand" id={item?._id} tab={item?._id}>
                  <td
                    colSpan="4"
                    style={{ position: "relative" }}
                    className="expand_wrap"
                  >
                    <table className="table-commission">
                      <tbody>
                        <tr>
                          <th width="9%">Bet ID</th>
                          <th width="">Selection</th>
                          <th width="9%">Odds</th>
                          <th width="13%">Stake</th>
                          <th width="8%">Type</th>
                          <th width="16%">Placed</th>
                          <th width="23%">Profit/Loss</th>
                        </tr>
                        {item?.bets_list?.map((betData, i) => {
                          return (
                            <tr
                              id="txRow0"
                              style={{
                                display: "table-row",
                              }}
                              className="even"
                              tab={i + 1}
                            >
                              <td id="betID">
                                {tab == "Fancy"
                                  ? betData?.sessionBetId
                                  : betData?.matchBetId}
                              </td>
                              <td id="matchSelection">
                                {tab == "Fancy" || tab == "Sportsbook" ? (
                                  tab == "Sportsbook" ? (
                                    <>
                                      {betData?.fancyName}{" "}
                                      <img
                                        class="fromto"
                                        src={cdnImg("assets/images/transparent.gif")}
                                      />
                                      {betData?.runnerName}{" "}
                                    </>
                                  ) : (
                                    betData?.fancyName
                                  )
                                ) : (
                                  betData?.teamName
                                )}
                              </td>
                              <td id="txOddsMatched">
                                {tab == "Fancy"
                                  ? betData?.betRun + "/" + betData?.bhav
                                  : betData?.bhav}

                                {}
                              </td>
                              <td id="txStake">
                                {" "}
                                {toFixedWithoutRounding(betData?.amount)}
                              </td>
                              <td>
                                {tab == "Fancy" ? (
                                  <span
                                    id="matchType"
                                    className={
                                      betData?.type === "No" ? "lay" : "back"
                                    }
                                  >
                                    {capitalize(betData?.type)}
                                  </span>
                                ) : (
                                  <span
                                    id="matchType"
                                    className={
                                      betData?.betType === "lay"
                                        ? "lay"
                                        : "back"
                                    }
                                  >
                                    {capitalize(betData?.betType)}
                                  </span>
                                )}
                              </td>
                              <td id="placed">
                                {moment(betData?.createdAt).format(
                                  "YYYY-MM-DD hh:mm:ss"
                                )}
                              </td>

                              <td id="txLiability">
                                <span
                                  style={{
                                    color:
                                      betData?.updatedResult > 0
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  {betData?.updatedResult > 0
                                    ? formatWithCommas(
                                        Math.abs(betData?.updatedResult)
                                      )
                                    : `(${formatWithCommas(
                                        Math.abs(betData?.updatedResult)
                                      )})`}
                                </span>
                              </td>
                            </tr>
                          );
                        })}

                        <tr className="sum-pl">
                          <td colSpan="7">
                            <dl
                              style={{
                                marginBottom: "0",
                              }}
                            >
                              <dt>Total Stakes</dt>
                              <dd id="totalStakes">
                                {formatWithCommas(
                                  Math.abs(item?.resultTotalStake)
                                )}
                              </dd>
                              <dt>
                                {tab == "Fancy"
                                  ? "Yes Subtotal"
                                  : "Back Subtotal"}
                              </dt>
                              <dd
                                style={{
                                  color:
                                    (tab == "Fancy"
                                      ? item?.yesSubTotalresult
                                      : item.backSubTotalresult) > 0
                                      ? "green"
                                      : "red",
                                }}
                                id="backSubTotal"
                              >
                                {formatWithCommas(
                                  Math.abs(
                                    tab == "Fancy"
                                      ? item?.yesSubTotalresult
                                      : item.backSubTotalresult
                                  )
                                )}
                              </dd>{" "}
                              <dt>
                                {tab == "Fancy"
                                  ? "No Subtotal"
                                  : "Lay Subtotal"}
                              </dt>
                              <dd
                                style={{
                                  color:
                                    (tab == "Fancy"
                                      ? item?.noSubTotalresult
                                      : item.laySubTotalresult) > 0
                                      ? "green"
                                      : "red",
                                }}
                                id="laySubTotal"
                              >
                                {formatWithCommas(
                                  Math.abs(
                                    tab == "Fancy"
                                      ? item?.noSubTotalresult
                                      : item.laySubTotalresult
                                  )
                                )}
                              </dd>{" "}
                              <dt>Market subtotal</dt>
                              <dd
                                style={{
                                  color:
                                    item?.marketSubTotal > 0 ? "green" : "red",
                                }}
                                id="marketTotal"
                              >
                                {formatWithCommas(
                                  Math.abs(item.marketSubTotal)
                                )}
                              </dd>
                              <dt>Commission</dt>
                              <dd id="commission">
                                {formatWithCommas(Math.abs(item.commission))}
                              </dd>
                              <dt>Net Market Total</dt>
                              <dd
                                style={{
                                  color: item?.netAmount > 0 ? "green" : "red",
                                }}
                                id="netTotal"
                              >
                                {formatWithCommas(Math.abs(item.netAmount))}
                              </dd>
                            </dl>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <img
                      class="expand-arrow-R"
                      src={cdnImg("assets/images/transparent.gif")}
                    ></img>
                  </td>
                </tr>
              )}
            </>
          )
        );
      })}
    </tbody>
  ) : (
    <tbody id="Matched_Content">
      <tr
        id="noDataTemplate"
        style={{
          display: "table-row",
        }}
      >
        <td className="no-data" colSpan="9">
          <p>You have no bets in this time period.</p>
        </td>
      </tr>
    </tbody>
  );
};

export default ProfitLoss;
